"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import useAuthStore from "@auth/store/useAuthStore";

export default function Home() {
  const { token } = useAuthStore();
  const router = useRouter();

  useEffect(() => {
    router.replace(token ? "/orders" : "/login");
  }, [token]);

  // Avoid flash — display nothing until the redirect occurs
  return null;
}